import { render, staticRenderFns } from "./HistorialDeclaracion.vue?vue&type=template&id=330a6dce&"
import script from "./HistorialDeclaracion.vue?vue&type=script&lang=js&"
export * from "./HistorialDeclaracion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports